// API configuration
// In development, Vite proxy handles /api calls
// In production, we need the full API URL
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export function getApiUrl(path: string): string {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  // If API_BASE_URL ends with /api, remove it from the path
  if (API_BASE_URL.endsWith('/api') && cleanPath.startsWith('/api')) {
    return `${API_BASE_URL}${cleanPath.substring(4)}`;
  }

  // If path starts with /api, use it as-is with base URL
  if (cleanPath.startsWith('/api')) {
    return `${API_BASE_URL}${cleanPath.substring(4)}`;
  }

  return `${API_BASE_URL}${cleanPath}`;
}
